/* RESPONSIBLE TEAM: team-reporting */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type TicketStateService from 'embercom/services/ticket-state-service';

export default class DataExportRoute extends Route {
  @service declare permissionsService: $TSFixMe;
  @service intl!: IntlService;
  @service declare appService: AppService;
  @service declare ticketStateService: TicketStateService;

  titleToken = this.intl.t('reporting.data-export.header');

  async beforeModel(transition: any) {
    if (this.appService.app.canUseNewDataExport) {
      await this.ticketStateService.setup();
      return this.permissionsService.ensurePermissionWhenTransitioning(
        'can_export_csv',
        transition,
      );
    } else {
      return this.transitionTo('apps.app.reports.overview');
    }
  }
}
